<template>
	<div style="padding-top: -2px; margin-top: -2px">
		<vc-select-generic
			ref="sDistrict"
			autocomplete
			class="text"
			itemtext="DtrName"
			itemvalue="DtrID"
			:disabled="disabled"
			id="DtrName"
			:value="value"
			:return-object="returnObject"
			@input="input($event)"
			:config="config"
			:label="label"
			:full="full"
			:autofocus="autofocus"
			:text="text"
			:clearable="clearable"
			:noDefault="noDefault"
			:outlined="outlined"
		></vc-select-generic>
	</div>
</template>

<script>
	import _sDistrict from "@/services/General/GenDistrictService.js"

	export default {
		name: "SelectDistrict",
		props : {
			autofocus: {
				type: Boolean,
				default: false,
			},
			disabled: {
				type: Boolean,
				default: false,
			},
			clearable: {
				type: Boolean,
				default: false,
			},
			value: null,
			text: {
				type: String,
				default: ""
			},
			label: {
				type: String,
				default: "",
			},
			returnObject: {
				type: Boolean,
				default: false,
			},
			noDefault: {
				type: Boolean,
				default: false,
			},
			full: {
				type: Boolean,
				default: false,
			},

			outlined: {
				type: Boolean,
				default: true
			},
			CceLevel : {
				type : Number,
				default : 100
			},
			PrvID : {
				type : Number,
				default : 0
			}
		},
		data() {
			return {
				item: 0,
				val: "",
				items: [],
				config: {},
			}
		},
		watch: {
			value(value) {
				this.item = value;
			},
			PrvID(){
				this.config.params.PrvID=this.PrvID
		    }

		},

		methods: {
			focus() {
				this.$refs.sDistrict.focus();
			},
			input(val) {
				this.$emit("input", val);
			},
		},

		created() {
			
			this.config = {
				url: _sDistrict.getUrlSearchDistrict(),
				title: this.label,
				params: {
					PrvID: this.PrvID
				},
			};
		},
	}
</script>